<template>
  <div class="user-main">
    <!-- header -->
    <div class="myHeader">
      <el-row>
        <el-col :span="16">
          <el-row>
            <el-col :span="7" class="myLogo">
              <img
                src="@/assets/dataViewImg/title-content.png"
                alt
                class="titleImg"
              />
              <h1>张江高科技智慧园区大脑</h1>
            </el-col>
            <el-col :span="14">
              <el-col :span="2" v-for="item in 10" :key="item" class="tabarList"
                >资产</el-col
              >
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <!-- 这里是天气和日期 -->
            <el-col :span="10">
              <el-row>
                <el-col :span="12" class="el-col12">
                  <div class="time">09:23:12</div>
                  <div class="date">2018.09-05</div>
                </el-col>
                <el-col :span="12" class="el-col12">
                  <div class>
                    <span class="time">27/27°C</span>
                  </div>
                  <div class="weather">雨夹雪</div>
                </el-col>
              </el-row>
            </el-col>
            <!-- 这里是空气指数 -->
            <el-col :span="14">
              <el-row>
                <el-col :span="7" class="center-font8">
                  <p>
                    空气指数:
                    <span class="cor03e">38优</span>
                  </p>
                  <p>
                    PM2.5：
                    <span class="cor03e">16</span>
                  </p>
                </el-col>
                <el-col :span="7" class="center-font8">
                  <p>PMID：33</p>
                  <p>
                    Co2：
                    <span class="cor03e">16</span>
                  </p>
                </el-col>
                <el-col :span="10" class="center-font8">
                  <p>
                    风向：
                    <span class="cor03e">东北风 3-14级</span>
                  </p>
                  <p>
                    湿度：
                    <span class="cor03e">48</span>
                  </p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- content -->
    <div class="content">
      <el-row class="height100">
        <!-- left -->
        <el-col :span="6" class="contentLeft">
          <div class="louceng">
            <p class="smallTip">今日楼层电能消耗情况</p>
            <div class="he80-pad10">
              <el-row class="height25">
                <el-col :span="12">
                  <p>
                    今日最大负荷：
                    <span class="cor03e">500Kw</span>
                  </p>
                </el-col>
                <el-col :span="12">
                  <p>
                    今日累计用点数：
                    <span class="cor03e">500Kw</span>
                  </p>
                </el-col>
              </el-row>
              <el-row class="height25">
                <el-col :span="12">
                  <p>
                    昨日最大负荷：
                    <span class="cor03e">500Kw</span>
                  </p>
                </el-col>
                <el-col :span="12">
                  <p>
                    昨日累计用电：
                    <span class="cor03e">500Kw</span>
                  </p>
                </el-col>
              </el-row>
              <el-row class="height25">
                <el-col :span="6" :offset="3">
                  <p>
                    环比：
                    <span class="cor03e">5%</span>
                    <img
                      class="w9-mar-left2"
                      src="@/assets/dataViewImg/icondown.png"
                      alt
                    />
                  </p>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="dianliang">
            <p class="smallTip">今日电能实时负荷统计</p>
            <div id="two"></div>
          </div>
          <div class="shishi">
            <p class="smallTip">今日实时耗电排名前十</p>
            <div class="h80-pad12">
              <el-row class="floor">
                <el-col :span="2">1</el-col>
                <el-col :span="6">KTJZ001</el-col>
                <el-col :span="8">15号楼F3</el-col>
                <el-col :span="8">33645Kw/h</el-col>
              </el-row>
              <el-row class="floor">
                <el-col :span="2">1</el-col>
                <el-col :span="6">KTJZ001</el-col>
                <el-col :span="8">15号楼F3</el-col>
                <el-col :span="8">33645Kw/h</el-col>
              </el-row>
              <el-row class="floor">
                <el-col :span="2">1</el-col>
                <el-col :span="6">KTJZ001</el-col>
                <el-col :span="8">15号楼F3</el-col>
                <el-col :span="8">33645Kw/h</el-col>
              </el-row>
              <el-row class="floor">
                <el-col :span="2">1</el-col>
                <el-col :span="6">KTJZ001</el-col>
                <el-col :span="8">15号楼F3</el-col>
                <el-col :span="8">33645Kw/h</el-col>
              </el-row>
              <el-row class="floor2">
                <el-col :span="2">1</el-col>
                <el-col :span="6">KTJZ001</el-col>
                <el-col :span="8">15号楼F3</el-col>
                <el-col :span="8">33645Kw/h</el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <!-- center -->
        <el-col :span="11" class="contentCenter">
          <div class="A1">
            <el-row class="mar-top1">
              <el-col :span="8" :offset="4">申通大厦</el-col>
              <el-col :span="3" :offset="8">F3层</el-col>
            </el-row>
          </div>
          <div class="A2">
            <h3 class="mar-top5-left10">电能消耗</h3>
            <div class="mar-top5-left10">
              <el-row>
                <el-col :span="12">实时负率</el-col>
                <el-col :span="12" class="cor26d">3255kw</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">当日累计用电</el-col>
                <el-col :span="12" class="cor26d">123344kw/h</el-col>
              </el-row>
            </div>
          </div>
          <div class="A3">
            <el-row class="mar10-15">
              <el-col :span="8">
                <p>室内</p>
                <p class="cor26d">25°C</p>
              </el-col>
              <el-col :span="16">
                <p>
                  湿度
                  <span class="cor26d">40%</span>
                </p>
                <p>
                  CO2
                  <span class="cor26d">16</span>
                </p>
                <p>
                  PM2.5
                  <span class="cor26d">16</span>
                </p>
              </el-col>
            </el-row>
          </div>
          <div class="A4">
            <el-row>
              <el-col
                v-for="item in 4"
                :key="item"
                :span="5"
                :offset="1"
                class="el-col-for4"
                >&nbsp;</el-col
              >
              <p class="p-align">XXXXXXXXX公司技术支持</p>
            </el-row>
          </div>
        </el-col>
        <!-- right -->
        <el-col :span="7" class="contentRight">
          <div class="B1">
            <p class="smallTip">本月大楼耗电量累计统计</p>
            <div class="h80-pad12">
              <el-row v-for="item in 3" :key="item" class="el-row-for3">
                <el-col :span="14">
                  当月累计 &nbsp;&nbsp;
                  <span class="cor03e">1133645Kw.h</span>
                </el-col>
                <el-col :span="10">
                  同比&nbsp;&nbsp;
                  <span class="cor19c">10%</span>
                  <img
                    class="w9p-mar-left5p"
                    src="@/assets/dataViewImg/icondown.png"
                    alt
                  />
                </el-col>
              </el-row>
              <el-row class="el-row2">
                <el-col :span="14">
                  当月累计 &nbsp;&nbsp;
                  <span class="cor03e">1133645Kw.h</span>
                </el-col>
                <el-col :span="10">
                  同比&nbsp;&nbsp;
                  <span class="corff0">10%</span>
                  <img
                    class="w9p-mar-left5p"
                    src="@/assets/dataViewImg/iconup.png"
                    alt
                  />
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="B2">
            <p class="smallTip mar-bot10">本月每日耗电趋势统计</p>
            <div id="RightTwo"></div>
          </div>
          <div class="B3">
            <p class="smallTip">今日实时耗电排名前十的空间</p>
            <div class="h80-pad12">
              <el-row v-for="item in 5" :key="item" class="el-row-for5">
                <el-col :span="2">1</el-col>
                <el-col :span="14">15号楼F3</el-col>
                <el-col :span="8">33645Kw/h</el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "agemain2",
  data() {
    return {};
  },
  mounted() {
    this.dianliang();
  },
  methods: {
    dianliang() {
      var myChart = this.$echarts.init(document.getElementById("two"));
      var myChart2 = this.$echarts.init(document.getElementById("RightTwo"));
      var option = {
        tooltip: {
          trigger: "axis"
        },
        // legend: {
        //     data: ["时用电能负荷（KW）"],
        //     x: "right"
        // },
        toolbox: {
          show: false,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: true
            },
            magicType: {
              show: false,
              type: ["line", "bar"]
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["0", "4", "8", "12", "16", "20", "24"],
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            nameTextStyle: {
              color: "rgb(0, 127, 127)"
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "°C",
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            nameTextStyle: {
              color: "#fff"
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        series: [
          {
            name: "时用电能负荷（KW）",
            type: "line",
            data: [300, 100, 1800, 2700, 2900, 3200, 290],
            label: {
              normal: {
                show: true,
                position: "top",
                textStyle: {
                  color: "white"
                }
              }
            },
            itemStyle: {
              normal: {
                color: "#fdba35", //改变折线点的颜色
                lineStyle: {
                  color: "#fdba35" //改变折线颜色
                }
              }
            }
          }
        ]
      };
      var option2 = {
        tooltip: {
          trigger: "axis"
        },
        toolbox: {
          show: false,
          feature: {
            mark: {
              show: true
            },
            dataView: {
              show: true,
              readOnly: true
            },
            magicType: {
              show: false,
              type: ["line", "bar"]
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
              "13",
              "14",
              "15",
              "16",
              "17",
              "18",
              "19",
              "20",
              "21",
              "22",
              "23",
              "24",
              "25",
              "26",
              "27",
              "28",
              "29",
              "30",
              "31"
            ],
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            nameTextStyle: {
              color: "rgb(0, 127, 127)"
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgb(255, 255,255)"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            nameTextStyle: {
              color: "rgb(244, 235, 243)"
            },
            splitArea: {
              areaStyle: {
                type: "default"
              },
              show: false
            },
            axisLabel: {
              textStyle: {
                color: "rgb(255,255, 255)"
              }
            }
          }
        ],
        series: [
          {
            label: {
              normal: {
                show: true,
                position: "top",
                textStyle: {
                  color: "white"
                }
              }
            },
            name: "时用电能负荷（KW）",
            type: "line",
            data: [
              1825,
              1459,
              2159,
              1494,
              1541,
              2454,
              1759,
              1499,
              1899,
              1499,
              1965,
              2234,
              1796,
              1985,
              2211,
              1500,
              500,
              2400,
              1860,
              1970,
              1500,
              400,
              1840,
              2454,
              1540,
              1406,
              1879,
              1464,
              1789,
              1564,
              2245
            ],
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#03ebeb"
                },
                color: "rgb(0, 0, 0)"
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      myChart2.setOption(option2);
    }
  }
};

{
}
</script>
<style lang="scss" scoped>
.user-main {
  font-family: å¾®è½¯é›…é»‘, MicrosoftYahei, sans-serif;
  color: rgb(255, 255, 255);
  width: 100%;
  height: 100%;
  background: url(../../assets/dataViewImg/background.png);
  background-size: 100% 100%;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  font-size: 0.7vw;
}
.content {
  width: 99%;
  height: 100%;
  box-sizing: border-box;
  margin: 1.5% 0.5%;
  .contentLeft {
    height: 100%;
    .smallTip {
      position: absolute;
      top: 11%;
      left: 34%;
      font-size: 0.8vw;
      font-weight: 700;
    }
    .louceng {
      height: 18%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      position: relative;
      margin-bottom: 1%;
    }
    .dianliang {
      height: 24%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      position: relative;
      margin-bottom: 1%;
    }
    .shishi {
      height: 24%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      position: relative;
      margin-bottom: 1%;
    }
  }
  .contentCenter {
    height: 100%;
    position: relative;
    .A1 {
      width: 33%;
      height: 3%;
      background: url(../../assets/dataViewImg/title-background.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      position: absolute;
      left: 3%;
      margin-bottom: 1%;
    }
    .A2 {
      width: 22%;
      height: 26%;
      background: url(../../assets/dataViewImg/frame.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      position: absolute;
      left: 35%;
      top: 20%;
      margin-bottom: 1%;
    }
    .A3 {
      width: 25%;
      height: 10%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      position: absolute;
      right: 3%;
      margin-bottom: 1%;
    }
    .A4 {
      width: 25%;
      height: 5%;
      // background: red;
      position: absolute;
      left: 37.5%;
      top: 80%;
      margin-bottom: 1%;
    }
  }
  .contentRight {
    height: 100%;
    .B1 {
      height: 27%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      position: relative;
      margin-bottom: 1%;
      .smallTip {
        position: absolute;
        top: 13%;
        left: 35%;
        // font-size:1em;
        font-weight: 700;
      }
    }
    .B2 {
      height: 27%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      position: relative;
      margin-bottom: 1%;
      .smallTip {
        position: absolute;
        top: 13%;
        left: 35%;
        // font-size:1em;
        font-weight: 700;
      }
    }
    .B3 {
      height: 27%;
      background: url(../../assets/dataViewImg/frame-2.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: top center;
      width: 100%;
      position: relative;
      margin-bottom: 1%;
      .smallTip {
        position: absolute;
        top: 13%;
        left: 35%;
        // font-size:1em;
        font-weight: 700;
      }
    }
  }
}
.myHeader {
  height: 6%;
  width: 100%;
  display: inline-block;
  margin-top: 15px;
  box-sizing: border-box;
  border-bottom: 1px solid #03ebeb;
  .titleImg {
    position: absolute;
    top: 0;
    left: 0px;
    height: 95%;
  }
  .myLogo {
    text-align: center;
    height: 6%;
    color: #03ebeb;
    font-size: 0.8vw;
  }
  .tabarList {
    text-align: center;
    background: url(../../assets/dataViewImg/tabar.png) center;
    background-size: 100% 100%;
    font-size: 0.4vw;
    line-height: 33px;
    background-repeat: no-repeat;
    height: 6%;
    text-align: center;
    margin-right: 1%;
    color: #eee;
  }
}
// 新增
.el-col12 {
  border-right: 2px solid #03ebeb;
  text-align: center;
}
.time {
  font-size: 1.2vw;
  color: #03ebeb;
}
.date {
  font-size: 1vw;
}
.center-font8 {
  text-align: center;
  font-size: 0.8vw;
}
.cor03e {
  color: #03ebeb;
}
.height100 {
  height: 100%;
}
.he80-pad10 {
  height: 80%;
  padding: 10%;
}
.height25 {
  height: 25%;
}
.w9-mar-left2 {
  width: 9px;
  margin-left: 2px;
}
#two {
  height: 100%;
  width: 80%;
  box-sizing: border-box;
  margin: 0 auto;
}
.h80-pad12 {
  height: 80%;
  padding: 12%;
}
.floor {
  height: 15%;
  border-bottom: 1px solid #213244;
}
.floor2 {
  height: 15%;
}
.mar-top1 {
  margin-top: 1%;
}
.mar-top5-left10 {
  margin-top: 5%;
  margin-left: 10%;
}
.cor26d {
  color: #26d3d1;
}
.mar10-15 {
  margin: 10% 15%;
}
.el-col-for4 {
  background: #76f2fe;
  height: 100%;
  border-radius: 15%;
}
.p-align {
  text-align: center;
  color: #fff;
}
.cor19c {
  color: #19c011;
}
.w9p-mar-left5p {
  width: 9px;
  margin-left: 5px;
}
.el-row2 {
  height: 15%;
  border-bottom: 1px solid #213244;
  border-top: 1px solid #213244;
}
.corff0 {
  color: #ff0114;
}
.mar-bot10 {
  margin-bottom: 10%;
}
#RightTwo {
  height: 100%;
  width: 80%;
  box-sizing: border-box;
  margin: 0 auto;
}
.el-row-for5 {
  height: 15%;
  border-bottom: 1px solid #213244;
}
</style>
